enum MutationListPosition {
  END = 'end',
  START = 'start',
}

export default MutationListPosition;
